import script from "./form-plan.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-plan.vue?vue&type=script&setup=true&lang=ts"

import "./form-plan.vue?vue&type=style&index=0&id=a6cd705e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6cd705e"]])

export default __exports__